import { useEffect, useState } from 'react';
import { leerSnapshotAccesos, obtenerConfiguracionAccesos } from '../services/adminService';

/**
 * Configuración de accesos del portal: los planes con Generador de Oferta y el
 * catálogo de grupos del plan Curso (cada uno con su perfil). El servicio cachea
 * la lectura, así que el Sidebar, el guard de rutas y el Generador comparten una
 * sola petición.
 *
 * `cargando` importa: hasta que la configuración llega no se sabe qué perfil
 * tiene un alumno del plan Curso, y decidir antes de tiempo dejaría entrar o
 * dejaría fuera a quien no toca.
 */
export default function useAccesosPortal() {
  // Si la configuración ya llegó en esta sesión se arranca con ella: así cambiar
  // de página no muestra un spinner por cada ruta protegida.
  const yaLeida = leerSnapshotAccesos();
  const [accesos, setAccesos] = useState(yaLeida || { generadorPlanes: [], grupos: [] });
  const [cargando, setCargando] = useState(!yaLeida);

  useEffect(() => {
    let activo = true;
    obtenerConfiguracionAccesos().then(config => {
      if (!activo) return;
      setAccesos(config);
      setCargando(false);
    });
    return () => { activo = false; };
  }, []);

  return { ...accesos, cargando };
}
